// Turn the homepage into a sequence of editorial chapters without taking over scrolling.
(function () {
    var home = document.querySelector('[data-edition-shift]');

    if (!home || !('IntersectionObserver' in window)) {
        return;
    }

    var sections = Array.prototype.slice.call(home.querySelectorAll('[data-edition-shift-section]'));
    var spine = home.querySelector('.edition-shift-spine');
    var spineLabel = spine && spine.querySelector('.edition-shift-spine-label');
    var spineList = spine && spine.querySelector('.edition-shift-spine-list');

    if (!sections.length || !spine || !spineLabel || !spineList) {
        return;
    }

    var links = sections.map(function (section, index) {
        var item = document.createElement('li');
        var link = document.createElement('a');
        var label = section.dataset.editionLabel || (home.dataset.sectionFallbackLabel || 'Section') + ' ' + (index + 1);

        if (!section.id) {
            section.id = 'edition-section-' + (index + 1);
        }

        link.href = '#' + section.id;
        link.setAttribute('aria-label', label);
        link.innerHTML = '<span aria-hidden="true"></span>';
        item.appendChild(link);
        spineList.appendChild(item);

        return link;
    });

    function activate(section) {
        var activeIndex = sections.indexOf(section);

        home.dataset.editionActive = section.dataset.editionTone || 'paper';
        spineLabel.textContent = section.dataset.editionLabel || home.dataset.editionFallbackLabel || 'Edition';

        links.forEach(function (link, index) {
            if (index === activeIndex) {
                link.setAttribute('aria-current', 'true');
            } else {
                link.removeAttribute('aria-current');
            }
        });
    }

    activate(sections[0]);
    spine.hidden = false;
    document.documentElement.classList.add('has-edition-shift');

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                activate(entry.target);
            }
        });
    }, {
        rootMargin: '-38% 0px -48% 0px',
        threshold: 0
    });

    sections.forEach(function (section) {
        observer.observe(section);
    });
})();
